export default __webpack_public_path__ + "static/media/FIL-BNB.e09e82ba.svg";